module.exports = __webpack_public_path__ + "static/media/26_tn.8476161c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/26_tn.jpg
// module id = 335
// module chunks = 0